var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubActivitiesFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66679 1.9974H9.33345L5.99345 6.1974L2.66679 1.9974ZM0.833452 1.7374C2.18012 3.46406 4.66679 6.66406 4.66679 6.66406V10.6641C4.66679 11.0307 4.96679 11.3307 5.33345 11.3307H6.66679C7.03345 11.3307 7.33345 11.0307 7.33345 10.6641V6.66406C7.33345 6.66406 9.81345 3.46406 11.1601 1.7374C11.2365 1.63898 11.2838 1.52108 11.2964 1.39713C11.3091 1.27319 11.2868 1.14817 11.2319 1.03631C11.177 0.924454 11.0918 0.830258 10.986 0.764447C10.8802 0.698636 10.758 0.663854 10.6335 0.664063H1.36012C0.806785 0.664063 0.493452 1.2974 0.833452 1.7374Z",
    fill: "#2A5578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubActivitiesFilter);
export default __webpack_public_path__ + "static/media/sub-activities-filter.fa9b24af16b9dcd24c9aea65c63b12d3.svg";
export { ForwardRef as ReactComponent };